<template>
    <div class="complaint-container clearfix swb-back-row">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }">投诉意见</el-breadcrumb-item>
                <el-breadcrumb-item>发起投诉</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="complaint-content mr15" style="margin-left: 0; ">
            <div class="title">投诉信息</div>
            <div class="form-info">
                <div class="form-row" v-if="isNotVoucher">
                    <div class="form-label">
                        <label class="required">投诉主题类型</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group v-model="model" @change="getComplaintTypeList(model)">
                            <el-radio v-for="(type, value) in subjectTypeList" :label="type.value">{{type.text}}</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <el-form :model="complaintInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">投诉类型</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="typeId">
                                <el-select v-model="complaintInfo.typeId" placeholder="请选择">
                                    <el-option v-for="item in complaintTypeList" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row" style="height: 90px">
                        <div class="form-label">
                            <label class="required">问题描述</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="content">
                                <el-input type="textarea" v-model="complaintInfo.content" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row" style="height: 90px;">
                        <div class="form-label">
                            <label class="required">处理要求</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="demand">
                                <el-input type="textarea" v-model="complaintInfo.demand" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label>联系人姓名</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="contactName">
                                <el-input type="text" v-model="complaintInfo.contactName"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label>联系人电话</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="contactTel">
                                <el-input type="text" v-model="complaintInfo.contactTel"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label>联系人邮箱</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="contactEmail">
                                <el-input type="text" v-model="complaintInfo.contactEmail"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <!-- 上传附件 -->
            <div class="form-info">
                <div class="form-row" style="overflow: hidden;height: auto">
                    <div class="form-label">
                        <label>上传附件</label>
                    </div>
                    <div class="form-value width-4x">
                        <div class="mt5">
                            <swb-file-upload :fileFor="'solution'" fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                            <div class="file-area clearfix">
                                <div class="mr15 inline-block" v-for="(complaintFile, index) in complaintFileList">
                                    <div class="file-item show-usage image deletable viewable downloadable editable" v-if="complaintFile.fileExtName == 'jpg' || complaintFile.fileExtName == 'png' || complaintFile.fileExtName == 'jpeg'|| complaintFile.fileExtName == 'JPEG'">
                                        <div class="file-content">
                                            <div class="usage ellipsis-1">{{complaintFile.fileName}}</div>
                                            <img :src="complaintFile.fileBrowseUrl"/>
                                            <div class="operation-group">
                                                <i class="icon iconfont icon-chakan view" @click="viewImage(complaintFile.fileBrowseUrl)"></i>
                                            </div>
                                            <div class="delete-icon" @click="removeUpload(index)"></div>
                                        </div>
                                    </div>
                                    <div class="file-item show-usage deletable viewable downloadable editable" v-else>
                                        <div class="file-content">
                                            <div class="usage ellipsis-1">{{complaintFile.fileName}}</div>
                                            <img :src="complaintFile.fileBrowseUrl"/>
                                            <div class="operation-group">
                                                <i class="icon iconfont icon-xiazai download" @click="downloadFile(complaintFile.fileUuid);"></i>
                                            </div>
                                            <div class="delete-icon" @click="removeUpload(index)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="form-toolbar align-center mt30" style="padding: 0;">
                <button class="swb-btn mr30" @click="$router.back(-1)">取消投诉</button>
                <button class="swb-btn mr20" @click="saveComplaint()">发起投诉</button>
            </div>
        </div>
        <div class="order-info" v-if="!isNotVoucher && complaintorderOrderInfo != null && complaintorderOrderInfo.id != null">
            <h4 class="title">订单信息</h4>
            <div class="order-content">
                <div class="order-content-row">
                    <div class="left">订单编号：</div>
                    <div class="right font-blue">{{complaintorderOrderInfo.no}}</div>
                </div>
                <div class="order-content-row">
                    <div class="left">总计：</div>
                    <div class="right font-red">{{complaintorderOrderInfo.amount}}元</div>
                </div>
                <div class="order-content-row">
                    <div class="left">提交时间：</div>
                    <div class="right">{{complaintorderOrderInfo.submitTime}}</div>
                </div>
                <div class="order-content-row">
                    <div class="left">商家：</div>
                    <div class="right font-blue">{{complaintorderOrderInfo.sellerName}}</div>
                </div>
            </div>
        </div>
        <div class="order-info" v-if="isNotVoucher && model != 0"><!--model == 0 为 平台服务 -->
            <h4 class="title"><span>被投诉商家</span><a class="swb-btn-link fr" style="margin-top: 7px" @click="chooseBusiness()">选择被投诉商家</a></h4>
            <div class="order-content">
                <div class="order-content-row">
                    <div class="left">商户名称：</div>
                    <div class="right font-blue">{{merchantBizRel.peerMerchantName}}</div>
                </div>
                <div class="order-content-row">
                    <div class="left">开始日期：</div>
                    <div class="right">{{merchantBizRel.dateStart}}</div>
                </div>
                <div class="order-content-row">
                    <div class="left">截止日期：</div>
                    <div class="right">{{merchantBizRel.dateEnd}}</div>
                </div>
                <div class="order-content-row">
                    <div class="left">星级标记：</div>
                    <div class="right font-blue">
                        <span class="font-red" v-if="merchantBizRel.starLevel == 0">待入围</span>
                        <span class="font-black" v-else>{{merchantBizRel.starLevel}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import custsvcApi from '../../api/custsvc'

    import SwbComplaintSendList from './ComplaintSendList';
    Routes.add(SwbComplaintSendList);

    import SwbMerchantBizRelSelect from '../merchant/MerchantBizRelSelect.vue';
    Vue.regist(SwbMerchantBizRelSelect);

    export default {
        name: 'swb-complaint-save',
        path: '/complaint/make',
        pathOld: '/complaint/save',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: false,
        parentBreadcrumbUrl: '/complaint/sent/list',
        desc: '发起投诉',
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            let contactTel = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMobileNo(value)) {
                        return callback(new Error('必须是手机号码'));
                    } else {
                        callback();
                    }
                }
            };
            let contactEmail = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isEmail(value)) {
                        return callback(new Error('必须是邮箱'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                complaintInfo: {
                    typeId: null,
                },
                complaintFileList: [],
                complaintTypeList: [],
                complaintorderOrderInfo: [],
                flag: false,        // 是否第一次发起投诉，用于提交投诉时，判断是否被投诉方信息
                mode: false,
                isNotVoucher: false,
                merchantBizRel: {},
                subjectTypeList: [],
                model: null,
                rules: {
                    typeId: [{validator: checkNull, trigger: 'blur'}],
                    content: [{validator: checkNull, trigger: 'blur'}],
                    demand: [{validator: checkNull, trigger: 'blur'}],
                    contactTel: [{validator: contactTel, trigger: 'blur'}],
                    contactEmail: [{validator: contactEmail, trigger: 'blur'}]
                },

                mySelfSendComplaint: false, // 是否 是从订单发起的投诉
            }
        },
        created: function () {
            let self = this;
            // 第一次从各订单发起的
            /*let subjectId = this.$route.query.id;  // 订单id
             let subjectNo = this.$route.query.no;   // 订单no
             let subjectType = this.$route.query.subjectType;   // 订单类型
             let tradeId = this.$route.query.tradeId;
             let tradeNo = this.$route.query.tradeNo;
             let tradeType = this.$route.query.tradeType;
             let sellerId = this.$route.query.sellerId;
             let sellerType = this.$route.query.sellerType;
             let SellerComId = this.$route.query.SellerComId;
             self.orderInfo = this.$route.query.orderInfo;    // orderInfo 需要以上数据从 订单 带过来的*/

            self.isNotVoucher = this.$route.query.isNotVoucher || false; // 是否基于单据发起投诉
            let subjectId = this.$route.query.orderId;  // 订单id
            let subjectType = this.$route.query.subjectType;   // 订单类型
            // 第一次发起投诉时调用...
            if(!Utils.isNoB(subjectId)) {
                let params = {};
                self.flag = true;
                params.subjectId = subjectId;
                params.subjectType = subjectType;
                //
                this.getOrderInfo(params);
                // 投诉类型
                this.getComplaintTypeList(subjectType);
            }

            // 再次投诉时调用...
            let complaintId = this.$route.query.complaintId;
            self.mode = this.$route.query.mode;
            if(!Utils.isNoB(complaintId)) {
                this.getComplaintInfo(complaintId);
            }
            // 不基于单据投诉 , 投诉主题类型
            if(self.isNotVoucher) {
                //
                let subjectTypeList = getEnumList("complaintSubjectType");
                for(let i = 0; i < subjectTypeList.length; i++) {
                    let subjectTypeValue = subjectTypeList[i].value;
                    let isSplice = subjectTypeValue === 1 || subjectTypeValue === 2 || subjectTypeValue === 3 || subjectTypeValue === 4 || subjectTypeValue === 5;
                    if(isSplice) {
                        subjectTypeList.splice(i, 1);
                        i--;
                    }
                }
                // subjectTypeList.splice(1, 5);
                this.subjectTypeList = subjectTypeList;
            }
        },
        methods: {
            // 获取投诉信息（重新申诉时...）
            getComplaintInfo: function (complaintId) {
                let self = this;
                let postData = {};
                postData.id = complaintId;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintInfo = result.data;
                        self.complaintFileList = self.complaintInfo.complaintFileList;
                        if(self.complaintFileList == null) {
                            self.complaintFileList = [];
                        }
                        let subjectType = self.complaintInfo.subjectType;
                        // 获取订单信息
                        let params = {};
                        params.subjectId = self.complaintInfo.subjectId;
                        params.subjectType = subjectType;
                        //
                        self.getOrderInfo(params);
                        // 投诉类型
                        self.getComplaintTypeList(subjectType);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 订单信息
            getOrderInfo: function (params) {
                let self = this;
                let postData = {};
                postData.subjectId = params.subjectId;
                postData.subjectType = params.subjectType;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintOrderInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintorderOrderInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取投诉类型
            getComplaintTypeList: function (subjectType) {
                let self = this;
                let postData = {};
                postData.subjectType = subjectType;
                let theLoad = MsgBox.loading();
                custsvcApi.getComplaintTypeList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintTypeList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择商家
            chooseBusiness: function () {
                let self = this;
                Vue.$showDialog({
                    title: '发起投诉',
                    showCloseBtn: true,
                    width: 900,
                    height: 550,
                    template: '<div>' +
                    '<swb-merchant-biz-rel-select :propMerchantType="propMerchantType" ref="swb_merchant_biz_rel_select_info"></swb-merchant-biz-rel-select>' +
                    '</div>',
                    data: {
                        loading: false,
                        propMerchantType: getEnumInfoWith("merchantType", "name", "Retailer").value
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_merchant_biz_rel_select_info.getDlgResult() || null;
                        if(result.type == 'info') {
                            //
                            self.merchantBizRel = result.data;
                            // console.log('被投诉方.......');
                            // console.log(self.merchantBizRel);
                            // 标记 不是同订单发起的投诉 （没有订单信息的）
                            self.mySelfSendComplaint = true;
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                });
            },

            // 发起投诉
            saveComplaint: function () {
                let self = this;
                self.$refs["ruleForm"].validate(function (value) {
                    if(value) {
                        let postData = self.complaintInfo;
                        //
                        if(self.flag) {
                            // 订单信息
                            postData.subjectId = self.complaintorderOrderInfo.id;
                            postData.subjectNo = self.complaintorderOrderInfo.no;
                            postData.tradeId = self.complaintorderOrderInfo.tradeId;
                            postData.tradeNo = self.complaintorderOrderInfo.tradeNo;
                            postData.tradeType = self.complaintorderOrderInfo.tradeType;
                            postData.contractOriginalNo = self.complaintorderOrderInfo.contractOriginalNo;
                            // 被投诉方信息
                            postData.dstMerchantId = self.complaintorderOrderInfo.buyerId; //
                            postData.dstMerchantType = self.complaintorderOrderInfo.buyerType; //
                            // postData.dstMerchantComId = self.complaintorderOrderInfo.sellerComId; //
                        }
                        // 附件信息
                        postData.complaintFileList = self.complaintFileList;
                        // 是否提交平台仲裁
                        if(self.mode) {
                            postData.mode = 1;  // 平台仲裁
                        }
                        // 不是从订单发起的投诉
                        if(self.mySelfSendComplaint && self.model != 0) { // model != 0  非 投诉平台时
                            postData.dstMerchantId = self.merchantBizRel.peerMerchantId; //
                            postData.dstMerchantType = self.merchantBizRel.peerMerchantType; //
                            // postData.dstMerchantComId = self.merchantBizRel.sellerComId; //
                        }
                        //
                        if(Utils.isNoB(postData.dstMerchantId) && self.model != 0) {
                            MsgBox.warning("未选择被投诉方信息");
                            return;
                        }
                        let theLoad = MsgBox.loading();
                        custsvcApi.saveComplaint(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                MsgBox.success("投诉成功！");
                                self.$router.push({
                                    path: SwbComplaintSendList.path
                                });
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },

            // 文件上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        self.complaintFileList.push(files[i]);
                    }
                } else {
                    this.$message.success(result.message);
                }
            },
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            removeUpload: function (index) {
                let self = this;
                self.complaintFileList.splice(index, 1);
            },
            downloadFile: function (fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/custsvc/ComplaintSave.vue